import styled from 'styled-components'
import { Tooltip } from 'antd'
import { TalhaoCultivaveisItens } from '../../../../../../../services/TalhaoSafra'
import Icon from '@ant-design/icons'
import Svg from '../../../../../../../Components/talhasvg'
import ButtonCustom from '../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faDownload, faMap, faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import Input from '../../../../../../../Components/CustomUi/input'
import { SetStateAction } from 'react'
import { DeleteButton } from '../../../../../../../Components/CustomUi/deleteButton'

//STYLES
const TabelaProp = styled.div`
  background: white;
  z-index: 2;
  border-radius: 8px;
  box-sizing: border-box;

  div.TabelaProp__header {
    display: flex;
    height: 25px;
    div.TabelaProp__header__item {
      width: 33%;
      height: 100%;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 13px;
      color: var(--text-color);
    }
    div.TabelaProp__header__item.subarea {
      width: 15%;
    }
    div.TabelaProp__header__item.talhao_nome {
      width: 45%;
    }

    div.TabelaProp__header__item.area_talhao {
      width: 15%;
    }
    div.TabelaProp__header__item.acoes {
      width: 20%;
    }
  }

  div.TabelaProp__container {
    width: 100%;
    max-height: calc(100vh - 515px);
    overflow-y: auto;

    div.TabelaProp__container__row {
      width: 100%;
      height: 50px;
      display: flex;
      font-weight: 500;
      font-size: 12px;
      color: var(--text-color);
      margin-bottom: 10px;

      .TabelaProp__container__row__item {
        height: 100%;
        align-items: center;
        box-sizing: border-box;
        padding: 10px 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        gap: 3px;

        .TabelaProp__container__row__item__color {
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
      /* :hover {
                background-color: var(--hover-color);
            } */
      .TabelaProp__container__row__item.talhao_nome {
        width: 45%;
        text-transform: capitalize;
        padding-left: 0px;
      }
      .TabelaProp__container__row__item.subarea {
        width: 15%;
        height: 50px;
        text-transform: capitalize;
        padding-left: 0px;
      }
      .TabelaProp__container__row__item.area_talhao {
        width: 15%;
        padding-left: 0px;
      }
      .TabelaProp__container__row__item.acoes {
        width: 20%;
        padding-left: 0px;
      }
      .TabelaProp__container__row__item.area_talhao:is([data-padding='true']) {
        padding-left: 3px;
      }
    }
  }
`

//PROPS
interface Props {
  dados_subarea: any[]
  excluir_subarea: Function
  baixarKmlSubarea: Function
  editarSubArea: Function
  salvarEditar: Function
  editIndexSubTalhao: number
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  urlRef: React.RefObject<HTMLAnchorElement>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number | string>>
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  loadingSalvar: boolean
}

export const TabelaPropSubArea: React.FC<Props> = ({
  dados_subarea,
  baixarKmlSubarea,
  editarSubArea,
  salvarEditar,
  excluir_subarea,
  editIndexSubTalhao,
  nome,
  setNome,
  urlRef,
  confirmar_exclusao,
  fake_loading,
  id_item_atual,
  setConfirmar_exclusao,
  setId_item_atual,
  setNome_item_atual,
  loadingSalvar
}) => {

  return (
    <TabelaProp>
      <div className='TabelaProp__header'>
        <div className='TabelaProp__header__item subarea'>Subárea</div>
        <div className='TabelaProp__header__item talhao_nome'>Nome</div>
        <div className='TabelaProp__header__item area_talhao'>Área</div>
        <div className='TabelaProp__header__item acoes'>Ações</div>
      </div>
      <div className='TabelaProp__container'>
        {(dados_subarea ?? []).map((item, index) => {
          let temp = []

          for (let i = 0; i < item.subArea.length; i += 1) {
            const coord = item.subArea[i]
            temp = [...temp, coord.toJSON()]
          }
          //@ts-ignore
          const coordenadas: [string | number, string | number] = temp
          
          return (
            <div className='TabelaProp__container__row' key={item?.cod}>
              <div
                className='TabelaProp__container__row__item subarea'
                data-padding={dados_subarea?.length > 11}
              >
                <Svg fill='var(--primary-color, green)' coordinates={coordenadas} />
              </div>
              <a ref={urlRef} style={{ display: 'none' }} href=''>
                Link
              </a>

              <Tooltip title={item?.nome} mouseEnterDelay={1}>
                <div
                  className='TabelaProp__container__row__item talhao_nome'
                  data-padding={dados_subarea?.length > 11}
                >
                  {editIndexSubTalhao === index ? (
                    <Input icon={faMap} placeholder='' value={nome} onChange={setNome} />
                  ) : (
                    String(item?.nome)?.toLowerCase()
                  )}
                </div>
              </Tooltip>

              <Tooltip title={`${item?.area} ha`} mouseEnterDelay={1}>
                <div
                  className='TabelaProp__container__row__item area_talhao'
                  data-padding={dados_subarea?.length > 11}
                >
                  {item?.area} ha
                </div>
              </Tooltip>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '5px',
                  alignItems: 'center',
                }}
              >
                <DeleteButton
                  open={confirmar_exclusao && id_item_atual === item?.cod}
                  trigger={setConfirmar_exclusao}
                  onTrigger={() => {
                    setId_item_atual(item?.cod)
                    setNome_item_atual(item?.nome)
                  }}
                  loading={fake_loading}
                  message={`o item ${item?.nome} será excluido!`}
                  deleteds={[item?.nome]}
                  onDelete={() => excluir_subarea(index)}
                  disabled={fake_loading}
                  typeButtonTrigger='tertiary'
                />
                <ButtonCustom
                  style={{
                    width: '30px',
                    height: '30px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onClick={() => baixarKmlSubarea(item?.arquivo, item?.nome)}
                  type='secondary'
                  icon={<FontAwesomeIcon icon={faDownload} />}
                />
                <ButtonCustom
                  style={{
                    width: '30px',
                    height: '30px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onClick={() =>
                    editIndexSubTalhao !== index
                      ? editarSubArea(index, item?.nome)
                      : salvarEditar(index)
                  }
                  icon={<FontAwesomeIcon icon={editIndexSubTalhao !== index ? faPen : faCheck} />}
                  loading={loadingSalvar}
                />
              </div>
            </div>
          )
        })}
      </div>
    </TabelaProp>
  )
}
